<div class="row">
  <div class="col-sm-6">
    <div style="text-align: right;" *ngIf="WriteAction">
      <button mat-raised-button color="primary" (click)="add()">
        Add
      </button>
    </div>
    <table mat-table matSort [dataSource]="dataSource" style="width: 100%;">
      <ng-container matColumnDef="addressType">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Address Type </th>
        <td mat-cell *matCellDef="let element">
          {{element.addressType}}
        </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Address </th>
        <td mat-cell *matCellDef="let element">
          {{element.addressLine1}}{{element.addressLine2 ? ", " + element.addressLine2: ""}}
          {{element.city ? element.city + ', ' : ""}}
          {{element.stateCode ? element.stateCode : ""}}
          {{element.countryCode ? " " + element.countryCode : ""}}
          {{element.postalCode ? " " + element.postalCode : ""}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row [ngClass]="{'row_select': row.personAddressId === this.personAddress.personAddressId }"
        *matRowDef="let row; columns: displayedColumns;" (click)="edit(row)"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
  <div class="col-sm-6" *ngIf="isShown">
    <div [formGroup]="addressFormGroup" [ngClass]="{disabledDiv: !WriteAction}">
      <div style="text-align: right;" *ngIf="WriteAction">
        <button mat-raised-button color="primary" [disabled]="!addressFormGroup.valid" (click)="onSubmit()">
          {{this.personAddress && this.personAddress.personAddressId !== null ? 'Update': 'Save'}}
        </button>
        &nbsp;
        <button mat-raised-button (click)="cancel()">
          Cancel
        </button>
        &nbsp;
        <button color="warn" *ngIf="this.personAddress && this.personAddress.personAddressId !== null"
          (click)="delete(this.personAddress.personAddressId)" mat-raised-button (click)="cancel()">
          Delete
        </button>
      </div>
      <br>
      <mat-divider></mat-divider>
      <br>
      <div class="row">
        <div class="col-sm-6">
          <mat-slide-toggle [checked]="isUSAddress" (change)="toggleChangeEvent($event )">Live in United States ?</mat-slide-toggle>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Address Type</mat-label>
            <mat-select required formControlName="addressTypeId">
              <mat-option>--SELECT--</mat-option>
              <mat-option *ngFor="let item of addressTypeList" [value]="item.id">
                {{item.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <mat-form-field [hidden]="true">
            <input matInput formControlName="personAddressId">
          </mat-form-field>
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Address Line1</mat-label>
            <input matInput required placeholder="Address Line1" maxlength="150" formControlName="addressLine1">
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Address Line2</mat-label>
            <input matInput placeholder="Address Line2" maxlength="150" formControlName="addressLine2">
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>City</mat-label>
            <input matInput required placeholder="City" maxlength="150" formControlName="city">
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="isUSAddress">
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>State</mat-label>
            <mat-select required formControlName="stateId">
              <mat-option>--SELECT--</mat-option>
              <ng-container *ngFor="let item of stateList">
                <mat-option *ngIf="evalBind(item,personAddress.stateId)" [value]="item.id">
                    {{item.description}}
                </mat-option>
              </ng-container>             
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Zip Code</mat-label>
            <input matInput type="number" required placeholder="Zip Code" onKeyPress="if(this.value.length==6) return false;"
              formControlName="postalCode">
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="!isUSAddress">
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>State/Province Name</mat-label>
            <input matInput placeholder="Province Name" maxlength="100" formControlName="provinceName">
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Postal Code</mat-label>
            <input matInput required placeholder="Postal Code" (keyup)="changeValue($event)" maxlength="25"
              formControlName="postalCode">
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field style="display:flex;flex-direction: column">
            <mat-label>Country</mat-label>
            <input matInput placeholder="Country Code" maxlength="25" formControlName="countryCode">
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>